<div class="alert" *ngIf="message" (click)="doneMessageView()">
  <section>
    <div>
      <span class="success" *ngIf="message.type == 'success'">
        <i class="fas fa-check"></i>

      </span>
      <span class="error" *ngIf="message.type == 'error'">
        <i class="fas fa-times"></i>

      </span>
      <p>
        {{message.message}}
      </p>
    </div>
  </section>
</div>
